import React from "react";
import { useLanguage } from "../context/LanguageContext";
import NorthEastRoundedIcon from "@mui/icons-material/NorthEastRounded";

export const NavBar = () => {
    const { lang, setLang, t } = useLanguage();
    const links = [
        { key: "nav.cases", href: "#cases" },
        { key: "nav.skills", href: "#skills" },
        { key: "nav.about", href: "#top" },
    ];
    return (
        <header
            data-testid="site-nav"
            className="sticky top-0 z-40 backdrop-blur-md"
            style={{
                background: "rgba(246, 239, 230, 0.82)",
            }}
        >
            <div className="max-w-[1320px] mx-auto px-6 lg:px-12 h-[72px] flex items-center justify-between">
                <a
                    href="/"
                    data-testid="nav-brand"
                    className="flex items-center gap-2"
                >
                    <span
                        className="font-serif-display text-[22px] leading-none"
                        style={{ color: "var(--ink)" }}
                    >
                        Charlyn{" "}
                        <span
                            className="italic"
                            style={{ color: "var(--terracotta)" }}
                        >
                            De Wulf
                        </span>
                    </span>
                </a>
                <nav className="hidden md:flex items-center gap-9">
                    {links.map((l) => (
                        <a
                            key={l.key}
                            href={l.href}
                            data-testid={`nav-${l.key.split(".")[1]}`}
                            className="font-mono-archive text-[11px] archive-link"
                        >
                            {t(l.key)}
                        </a>
                    ))}
                </nav>
                <div className="flex items-center gap-3">
                    <div
                        data-testid="lang-toggle"
                        className="flex items-center text-[11px] font-mono-archive rounded-full overflow-hidden"
                        style={{
                            background: "var(--paper)",
                        }}
                    >
                        {["en", "nl"].map((code) => (
                            <button
                                key={code}
                                onClick={() => setLang(code)}
                                data-testid={`lang-${code}`}
                                className="px-3 py-1.5 transition-colors"
                                style={{
                                    background:
                                        lang === code
                                            ? "var(--ink)"
                                            : "transparent",
                                    color:
                                        lang === code
                                            ? "var(--paper)"
                                            : "var(--ink-soft)",
                                }}
                            >
                                {code.toUpperCase()}
                            </button>
                        ))}
                    </div>
                    <a
                        href="#contact"
                        data-testid="nav-get-in-touch"
                        className="pill pill-primary hidden sm:inline-flex"
                        style={{ padding: "10px 18px", fontSize: "11px" }}
                    >
                        {t("nav.cta")}
                        <NorthEastRoundedIcon sx={{ fontSize: 16 }} />
                    </a>
                </div>
            </div>
        </header>
    );
};
